import React from 'react';
import PropTypes from 'prop-types';
import {RenderHTML} from '@learningblocks/storybook-components';

export function Question({className, question}) {
  return (
    <div className={className}>
      <h6>Question</h6>
      <RenderHTML content={question} />
    </div>
  );
}

Question.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string.isRequired,
  /**
   * The prop that holds the text for the question
   */
  question: PropTypes.string.isRequired,
};
